"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSuggestion = exports.buildFormattedSuggestions = void 0;
const types_1 = require("../../types");
const sortFormattedSuggestions_1 = require("./sortFormattedSuggestions");
const findCategoryDisplayText_1 = require("./findCategoryDisplayText");
/**
 * Builds and returns the sorted options for the typeahead dropdown
 * @param config Config
 * @param response TypeaheadResponse
 * @param pmcUrl string (optional)
 * @returns FormattedSuggestion[]
 */
function buildFormattedSuggestions(config, response, pmcUrl) {
    var _a;
    const result = [];
    for (const category in response) {
        if ((0, types_1.isValidTypeaheadCategory)(category)) {
            (_a = response[category]) === null || _a === void 0 ? void 0 : _a.forEach((suggestion) => {
                result.push(buildSuggestion(category, suggestion, config, pmcUrl));
            });
        }
    }
    return (0, sortFormattedSuggestions_1.sortFormattedSuggestions)(config, result);
}
exports.buildFormattedSuggestions = buildFormattedSuggestions;
/**
 * Builds a formatted suggestion, which is an object that's passed down as an
 * option to the MUI Autocomplete (in an array)
 * @param category ValidTypeaheadCategory
 * @param suggestion TypeaheadSuggestion
 * @param config Config
 * @param pmcUrl string (optional)
 * @returns FormattedSuggestion
 */
function buildSuggestion(category, suggestion, config, pmcUrl) {
    const { highlight, name, synonym, score } = suggestion;
    const { use_specialty_name_in_typeahead, group_suggestions_by_category } = config.params;
    const categoryText = (0, findCategoryDisplayText_1.findCategoryDisplayText)(config, category);
    const categoryDisplayText = `<span class='category-text'> - ${categoryText}</span>`;
    let highlightText;
    let specialtyHighlightText;
    if (group_suggestions_by_category) {
        highlightText = highlight;
        if (category === 'specialties' && highlight && synonym) {
            specialtyHighlightText = `${highlight} <em>in ${synonym}</em>`;
        }
    }
    else {
        highlightText = `${highlight}${categoryDisplayText}`;
        if (category === 'specialties' && highlight && synonym) {
            specialtyHighlightText = `${highlight} <em>in ${synonym}</em>${categoryDisplayText}`;
        }
    }
    return {
        category: category,
        categoryDisplayText: categoryText,
        highlight: use_specialty_name_in_typeahead
            ? name
            : specialtyHighlightText || highlightText,
        name: name,
        queryString: buildQueryStringForSuggestion(config, category, suggestion, pmcUrl),
        score: score || 0
    };
}
exports.buildSuggestion = buildSuggestion;
/**
 * Builds the query string for the PMC URL to hit on click of a typeahead suggestion.
 * Typeahead categories map directly to the query string params, any additional params
 * should be pulled from the config and appended as necessary here
 * @param config Configt
 * @param category ValidTypeaheadCategory | ValidTypeaheadCategoryV8
 * @param suggestion TypeaheadSuggestion | TypeaheadSuggestionV8
 * @param pmcUrl string (optional)
 * @returns string
 */
function buildQueryStringForSuggestion(config, category, suggestion, pmcUrl) {
    const params = new URLSearchParams();
    const baseUrl = pmcUrl ? pmcUrl : '';
    params.append(category, suggestion.name);
    params.append('sort', config.params.sort_order.join(','));
    return `${baseUrl}/search?${params.toString()}`;
}
//# sourceMappingURL=buildFormattedSuggestions.js.map